import { Experience } from '@components'
import { DoubleTapPreventer, GUI } from '@components/helpers'
import { StrictMode } from 'react'

export default function App() {
  return (
    <>
      <GUI />
      <DoubleTapPreventer />

      <StrictMode>
        <Experience />
      </StrictMode>

      <div className="fixed bottom-4 inset-x-4 font-jb-mono text-white text-[8px] md:text-xs z-10">
        <p>
          Building construction crane by Kieran Farr [
          <a target="_blank" href="https://creativecommons.org/licenses/by/3.0/">
            CC-BY
          </a>
          ] via{' '}
          <a target="_blank" href="https://poly.pizza/m/cm5teXZ5Ctr">
            Poly Pizza
          </a>
        </p>
        <p>
          Bulldozer by Poly by Google [
          <a target="_blank" href="https://creativecommons.org/licenses/by/3.0/">
            CC-BY
          </a>
          ] via{' '}
          <a target="_blank" href="https://poly.pizza/m/ddxtaegI3HQ">
            Poly Pizza
          </a>
        </p>
        <p>
          Construction sign by koen caspers [
          <a target="_blank" href="https://creativecommons.org/licenses/by/3.0/">
            CC-BY
          </a>
          ] via{' '}
          <a target="_blank" href="https://poly.pizza/m/4v9QhryzBwT">
            Poly Pizza
          </a>
        </p>
      </div>
    </>
  )
}
